import { CardType } from '../../type';
import styles from './card-mobile.module.css';

interface CardProps {
  dataCard: CardType;
}

const CardMobile: React.FC<CardProps> = ({ dataCard }) => {
  const { cardItems, isActionHandling, nameAsset, numberAsset } = dataCard;

  return (
    <div className={styles.card}>
      <div className={styles.cardCommonInfo}>
        <div className={styles.commonInfoDesc}>
          <div className={styles.descTitle}>{nameAsset}</div>
          <div style={{ fontSize: '10px' }}>Asset No. {numberAsset}</div>
        </div>

        {isActionHandling && <div> Asset Handle </div>}
      </div>
      <div className={styles.cardActions}>
        {cardItems.map((item) => (
          <div key={`${item.label}+${item.value}`} className={styles.cardInfo}>
            <div>{item.label}</div>
            <div className={styles.cardInfoValue}>{item.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CardMobile;
